import React, { FC } from "react";

import styled from "styled-components";

const NumberBadgeContainer = styled.div<{ $small: boolean }>`
    display: flex;
    width: ${(props) => (props.$small ? "23px" : "24px")};
    min-width: ${(props) => (props.$small ? "23px" : "24px")};
    height: ${(props) => (props.$small ? "20px" : "24px")};
    min-height: ${(props) => (props.$small ? "20px" : "24px")};
    background-color: var(--color-tertiary);
    border-radius: 12px;

    .number {
        display: flex;
        align-items: center;
        margin: auto;
        font-size: ${(props) => (props.$small ? "var(--size-10)" : "var(--size-16)")};
        font-style: normal;
        font-weight: 400;
        line-height: ${(props) => (props.$small ? "16px" : "24px")};
        color: var(--color-tertiary-fg);
        text-align: center;
    }
`;

const NumberBadge: FC<{ value: number; small?: boolean }> = ({ value, small = false }) => {
    return (
        <NumberBadgeContainer $small={small}>
            <span className="number">{value}</span>
        </NumberBadgeContainer>
    );
};

export default NumberBadge;
